var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat303(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_303"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_303",
    "data-name": 303,
    className: "cls-2",
    d: "M31.41,5.33C22.94,10.91,21,21.64,19.16,41.84c-2.75,29.58-4.05,44.46,0,48.79,12,12.87,45.57,8.41,58-9.1C95.89,55.1,63.89,2.53,42.1,2A19.86,19.86,0,0,0,31.41,5.33Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat303);
export default __webpack_public_path__ + "static/media/cat_303.161433493247509e2dac5ba57fcc2f62.svg";
export { ForwardRef as ReactComponent };